import { useState, useCallback } from "react";
import { useNavigate } from "../router";
import { createQuickChatTicket, fetchQuickChatTickets } from "../api/quickChatTickets";
import { findRecentChatWithin72Hours } from "../utils/quickChatRecent";
import { showErrorToast } from "../utils/notifications";
import { toUserMessage } from "../utils/userMessage";

export function useQuickChatUserOpener({ onAfterNavigate } = {}) {
  const navigate = useNavigate();
  const [quickChatChoice, setQuickChatChoice] = useState(null);
  const [quickChatCreating, setQuickChatCreating] = useState(false);
  const [quickChatBusyUserId, setQuickChatBusyUserId] = useState(null);

  const handleQuickChatCreateAndOpen = useCallback(
    async (remoteId) => {
      setQuickChatCreating(true);
      try {
        const { ticket_id: ticketId } = await createQuickChatTicket(remoteId);
        navigate(`/chats/${ticketId}`);
        onAfterNavigate?.();
        setQuickChatChoice(null);
      } catch (e) {
        showErrorToast(toUserMessage(e?.message, "ایجاد گفت‌وگو ممکن نشد."));
      } finally {
        setQuickChatCreating(false);
      }
    },
    [navigate, onAfterNavigate]
  );

  const handleOpenQuickChatUser = useCallback(
    async (user, { tickets: searchTickets } = {}) => {
      if (!user?.remote_id || quickChatBusyUserId != null) return;

      setQuickChatBusyUserId(user.remote_id);
      try {
        let recent = findRecentChatWithin72Hours(searchTickets);

        if (!recent) {
          try {
            const fetched = await fetchQuickChatTickets(user.remote_id);
            recent = findRecentChatWithin72Hours(fetched);
          } catch {
            // اگر API در دسترس نبود، بدون مودال تلاش برای ایجاد مستقیم می‌کنیم
          }
        }

        if (recent) {
          setQuickChatChoice({ user, recentTicket: recent });
        } else {
          await handleQuickChatCreateAndOpen(user.remote_id);
        }
      } finally {
        setQuickChatBusyUserId(null);
      }
    },
    [quickChatBusyUserId, handleQuickChatCreateAndOpen]
  );

  const handleContinueRecentChat = useCallback(
    (ticketId) => {
      navigate(`/chats/${ticketId}`);
      onAfterNavigate?.();
      setQuickChatChoice(null);
    },
    [navigate, onAfterNavigate]
  );

  return {
    quickChatChoice,
    setQuickChatChoice,
    quickChatCreating,
    quickChatBusyUserId,
    handleOpenQuickChatUser,
    handleQuickChatCreateAndOpen,
    handleContinueRecentChat,
  };
}
